import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getDomainDashboardSummarySlice = createApi(`GetDomainDashboardSummarySlice`,"GET");

const GetDomainDashboardSummarySlice = createSlice({
  name: 'GetDomainDashboardSummarySlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDomainDashboardSummarySlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDomainDashboardSummarySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDomainDashboardSummarySlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetDomainDashboardSummarySlice.reducer;